import React from 'react'
import { FormattedMessage } from 'react-intl'
import SettingsEditField from '../settings-edit-field/index.jsx'
import SectionHeading from '../section-heading/index.jsx'
import messages from './messages.js'

const CommunicationPreferencesSection = () => (
  <React.Fragment>
    <SectionHeading {...messages.communicationPreferencesHeading} />
    <div className="py1" data-e2e="communication-preferences">
      <SettingsEditField
        label={<FormattedMessage {...messages.communicationPreferencesLabel} />}
        path="/account/settings/communication-preferences"
      />
    </div>
  </React.Fragment>
)

export default CommunicationPreferencesSection
